jQuery(function($){
    function header_slideshow_creator(){
        let curr_slide_num = 0;
        let slideshow;
        function header_slideshow(){
            let slide = $('.header_slideshow_cont > .slideshow_cont > .slide');
            let button = $('.slideshow_button');
            button.removeClass('active');
            slide.hide();
            slide.eq(curr_slide_num).fadeIn(1000);
            button.eq(curr_slide_num).addClass('active');
            curr_slide_num++;
            if(curr_slide_num >= slide.length){
                curr_slide_num = 0;
            }
        }
        $('.header_slideshow_cont > .slideshow_cont').append('<div class="slideshow_nav"></div>');
        $('.header_slideshow_cont > .slideshow_cont > .slide').each(function(){
            $('.slideshow_nav').append('<button class="slideshow_button"></button>');
        })
        $('.header_slideshow_cont > .slideshow_cont > .slide').hide();
        $('.header_slideshow_cont > .slideshow_cont > .slide').first().fadeIn(750);
        $('.slideshow_button').first().addClass('active');
        curr_slide_num++;
        $('.slideshow_button').on('click',function(){
            clearInterval(slideshow);
            curr_slide_num = $(this).index();
            let slide = $('.header_slideshow_cont > .slideshow_cont > .slide');
            let button = $('.slideshow_button');
            button.removeClass('active');
            slide.hide();
            slide.eq(curr_slide_num).fadeIn(1000);
            button.eq(curr_slide_num).addClass('active');
            curr_slide_num++;
            if(curr_slide_num >= slide.length){
                curr_slide_num = 0;
            }
            slideshow = setInterval(header_slideshow, 10000);
        })
    
        slideshow = setInterval(header_slideshow, 10000);
    }

    function slideshow_creator(){
        let curr_slide_num = 0;
        let slideshow;
        function header_slideshow(){
            let slide = $('.slideshow_with_description > .slideshow_cont > .slide');
            let button = $('.slideshow_button');
            button.removeClass('active');
            slide.hide();
            slide.eq(curr_slide_num).fadeIn(1000);
            button.eq(curr_slide_num).addClass('active');
            curr_slide_num++;
            if(curr_slide_num >= slide.length){
                curr_slide_num = 0;
            }
        }
        $('.slideshow_with_description').append('<div class="slideshow_nav"></div>');
        $('.slideshow_with_description > .slideshow_cont > .slide').each(function(){
            $('.slideshow_nav').append('<button class="slideshow_button"></button>');
        })
        $('.slideshow_with_description > .slideshow_cont > .slide').hide();
        $('.slideshow_with_description > .slideshow_cont > .slide').first().fadeIn(750);
        $('.slideshow_button').first().addClass('active');
        curr_slide_num++;
        $('.slideshow_button').on('click',function(){
            clearInterval(slideshow);
            curr_slide_num = $(this).index();
            let slide = $('.slideshow_with_description > .slideshow_cont > .slide');
            let button = $('.slideshow_button');
            button.removeClass('active');
            slide.hide();
            slide.eq(curr_slide_num).fadeIn(1000);
            button.eq(curr_slide_num).addClass('active');
            curr_slide_num++;
            if(curr_slide_num >= slide.length){
                curr_slide_num = 0;
            }
            slideshow = setInterval(header_slideshow, 10000);
        })
    
        slideshow = setInterval(header_slideshow, 10000);
    }

    header_slideshow_creator();
    slideshow_creator();
});